(ns frontend.view.grid.surveys-grid.mass-remind.view
  (:require [common.languages :as languages]
            [common.localization :as loc]
            [frontend.utils :as fu]
            [frontend.view.grid.surveys-grid.mass-remind.event :as event]
            [frontend.view.grid.surveys-grid.mass-remind.sub :as sub]
            [oops.core :as oops]
            [re-frame.core :as rf]
            [ui.components.alert.view :as alert]
            [ui.components.button.view :as button]
            [ui.components.grid.view :as grid]
            [ui.components.link.view :as link]
            [ui.components.modal.style :as modal-style]
            [ui.components.modal.view :as modal]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.components.tab-strip.view :as tab-strip]
            [ui.components.text.view :as text]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn lang-tabs
  []
  (let [selected-lang @(rf/subscribe [::sub/selected-lang])
        languages @(rf/subscribe [::sub/languages])
        language-counts @(rf/subscribe [::sub/language-counts])]
    [tab-strip/view
     {:selected-tab selected-lang
      :tabs         (->> languages
                         (mapv (fn [l]
                                 {:value l
                                  :label (fu/format "%s (%s)"
                                                    (languages/get-label l)
                                                    (get language-counts l 0))})))
      :on-change!   (fn [tab]
                      (rf/dispatch [::event/set-language tab]))}]))

(defn subject
  []
  (let [selected-lang @(rf/subscribe [::sub/selected-lang])
        subject @(rf/subscribe [::sub/subject])]
    ^{:key (str ::subject selected-lang)}
    [labelled-input/view
     {:label      (loc/tr :email/subject)
      :mandatory? true
      :value      subject
      :data-type  :data.type/text-simple
      :on-blur    (fn [new-value]
                    (rf/dispatch [::event/set-subject selected-lang new-value]))}]))

(def body-editor-options
  {:show-block-type? false
   :show-alignment?  false
   :link?            true
   :inline-options   [:bold :italic :underline]})

(defn body-field-label
  [{:keys [label mandatory?]}]
  [:label
   {:class "text-[14px] text-input-light-text font-semibold m-0"}
   [:span
    {:class "min-w-0"}
    label
    (when mandatory?
      [:span
       {:class "ml-1 text-danger-light-text font-bold"}
       "*"])]])

(defn body-1
  []
  (let [selected-lang @(rf/subscribe [::sub/selected-lang])
        body-part-1 @(rf/subscribe [::sub/body-1])]
    [:div
     {:class "flex flex-col gap-1.5"}
     [body-field-label
      {:label      (loc/tr :email-body-part-1)
       :mandatory? true}]
     ;; force component mount per language so the editor reloads its content
     ^{:key (str ::body-1 selected-lang)}
     [tiptap/editor
      (merge body-editor-options
             {:value     (or body-part-1 "")
              :on-change (fn [html]
                           (rf/dispatch [::event/set-body-1 selected-lang html]))})]]))

(defn link-preview
  []
  (let [selected-lang @(rf/subscribe [::sub/selected-lang])]
    [:div
     {:class "flex px-4"}
     [link/preview
      {:label (loc/tr :survey-email-link-preview-text nil (languages/long->short selected-lang))}]]))

(defn body-2
  []
  (let [selected-lang @(rf/subscribe [::sub/selected-lang])
        body-part-2 @(rf/subscribe [::sub/body-2])]
    [:div
     {:class "flex flex-col gap-1.5"}
     [body-field-label
      {:label (loc/tr :email-body-part-2)}]
     ;; force component mount per language so the editor reloads its content
     ^{:key (str ::body-2 selected-lang)}
     [tiptap/editor
      (merge body-editor-options
             {:value     (or body-part-2 "")
              :on-change (fn [html]
                           (rf/dispatch [::event/set-body-2 selected-lang html]))})]]))

(def column-defs
  [{:field        "id"
    :headerName   (loc/tr :uuid)
    :hide         true
    :flex         1
    :cellDataType "text"}
   {:field        "target"
    :headerName   (loc/tr :target)
    :flex         1
    :maxWidth     300
    :minWidth     160
    ;:rowGroup     true
    ;:hide         true
    :cellDataType "text"}
   {:field        "label"
    :headerName   (loc/tr :label)
    :flex         1
    :maxWidth     300
    :minWidth     160
    :cellDataType "text"}
   {:field        "invitees"
    :headerName   (loc/tr :invitees)
    :flex         1
    :minWidth     160
    :cellDataType "text"}])

(defn targets
  []
  (let [data @(rf/subscribe [::sub/selected-lang-processes-data])]
    [grid/ag-grid
     {:theme                         grid/theme-quartz
      :rowData                       data
      :columnDefs                    column-defs
      :domLayout                     :autoHeight
      :suppressContextMenu           true
      :suppressRowTransform          true
      :suppressRowHoverHighlight     true
      :rowBuffer                     100                                                            ;; Keep all rows in buffer
      :pinnedTopRowData              []
      :suppressLastEmptyLineOnPaste  true
      :stopEditingWhenCellsLoseFocus true
      :getRowId                      (fn [data-js]
                                       (str (oops/oget data-js "data.id")))
      :defaultColDef                 {:sortable                 true
                                      :filter                   false
                                      :cellClass                "absolute"
                                      :resizable                true
                                      :singleClickEdit          false
                                      :editable                 false
                                      :suppressHeaderMenuButton true
                                      :suppressMovable          false}}]))

(defn results-body
  []
  (let [results-data @(rf/subscribe [::sub/results-data])]
    [:div
     {:class "flex flex-col gap-4"}
     [text/h1
      {}
      (loc/tr :reminder-sending-results)]
     [:ul
      {:class "flex flex-col gap-2"}
      (->> results-data
           (group-by :process-id)
           (map (fn [[process-id process-results]]
                  ^{:key (str ::result "-" process-id)}
                  [:li
                   [:div
                    {:class "flex flex-row gap-2 items-baseline"}
                    [:i
                     {:class "fas "}]
                    [text/label
                     (:target-name (first process-results))]]
                   (into [:ul
                          {:class "flex flex-col gap-2 ms-4"}]
                         (->> process-results
                              (map (fn [result]
                                     [:li
                                      {:class "flex flex-row items-baseline gap-2"}
                                      [:i
                                       {:class "flex fas fa-envelope"}]
                                      [:label (:invitee-email result)]
                                      [:span
                                       (if (= :ok (:result result))
                                         [:i
                                          {:class "fas fa-check-circle text-primary-regular-text-accent"}]
                                         [:i
                                          {:class "fas fa-exclamation-triangle text-danger-regular"}])]]))
                              (doall)))]))
           (doall))]]))

(defn results-footer
  []
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::event/cancel]))}
     (loc/tr :close)]]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}]])

(defn body
  []
  [:div
   {:class "flex flex-col gap-4"}
   [:p
    (loc/tr :survey-email-reminder-info)]
   [alert/info
    {}
    (loc/tr :survey-email-reminder-info-note)]
   [lang-tabs]
   [subject]
   [body-1]
   [link-preview]
   [body-2]
   [targets]])

(defn footer
  []
  (let [validation-errors @(rf/subscribe [::sub/validation-errors])
        processing? @(rf/subscribe [::sub/processing?])]
    [:div
     {:class "flex flex-row flex-auto"}
     [:div
      {:class "flex flex-row justify-content-start"}
      [button/secondary-hollow
       {:on-click (fn [_]
                    (rf/dispatch [::event/cancel]))}
       (loc/tr :cancel)]]
     [:div
      {:class "flex flex-row flex-auto content-stretch justify-content-end"}
      [button/primary-solid
       {:disabled? (or (boolean validation-errors)
                       processing?)
        :tooltip   (when validation-errors
                     (into [:ul
                            {:class "flex flex-col gap-2"}]
                           (->> validation-errors
                                (map (fn [e]
                                       [:li
                                        {:class ""}
                                        e]))
                                (doall))))
        :on-click  (fn [_]
                     (rf/dispatch [::event/send-all!]))}
       (if-not processing?
         (loc/tr :send-all)
         [:i.fal.fa-spinner.fa-pulse])]]]))

(defn no-processes-footer
  []
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::event/cancel]))}
     (loc/tr :cancel)]]])

(defn loading-body
  []
  [:div
   {:class "py-8 flex flex-col gap-4 items-center justify-center"}
   [:svg
    {:class   "animate-spin h-8 w-8 mr-3 text-base-light-text fill-[#fff]"
     :viewBox "0 0 24 24"}
    [:circle
     {:class "opacity-75" :cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
    [:path
     {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
   (loc/tr :resolving-wip-surveys)])

(defn no-processes-body
  []
  [:div
   {:class "py-8 flex flex-col gap-4 items-center justify-center"}
   (loc/tr :no-processes-in-wip)])

(defn view
  []
  (let [open? @(rf/subscribe [::sub/modal-open?])
        results @(rf/subscribe [::sub/results])
        loading? @(rf/subscribe [::sub/loading?])
        processes @(rf/subscribe [::sub/selected-lang-processes-data])]
    [modal/view
     {:visible? open?
      :hide!    #(rf/dispatch [::event/cancel])
      :size     ::modal-style/full}
     (loc/tr :survey-mass-remind-modal)
     (cond loading?
           [loading-body]
           (empty? processes)
           [no-processes-body]
           results
           [results-body]
           :else
           [body])
     (cond loading?
           nil
           (empty? processes)
           [no-processes-footer]
           results
           [results-footer]
           :else
           [footer])]))
